<template>

</template>

<script>
export default {
  name: "CLOReportsPage"
}
</script>


